import {call, put, takeLatest, fork, all, delay} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as HomestayRoomTypeService from '../services/homestayRoomTypeService.js';
import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import {message} from 'antd'
import { setListHomestayRoomTypes as setListHomestayRoomTypesAction, setHomestayRoomType as setHomestayRoomTypeAction, saveHomestayRoomTypeSuccess, setAllHomestayRoomTypesByHotel } from '../actions/homestayRoomTypeAction';
import {PATHS} from "../constants/Define";
import {SAGA_DELAY_TIMEOUT} from '../constants/Define';
import { omit } from 'lodash';
import history from '../helpers/history';

function* setListHomestayRoomTypeSaga() {
    yield takeLatest(Types.HOMESTAY_ROOM_TYPE_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const limit = action.filters.pageSize ? action.filters.pageSize : undefined;
        const offset = action.filters.pageIndex ? (action.filters.pageIndex - 1) * limit : undefined;
        const hotel_id = action.filters.hotelId || undefined;
        const params = {
            ...omit(action.filters, ['pageIndex', 'pageSize']),
            limit, offset,hotel_id, 
        }
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(HomestayRoomTypeService.getHomestayRoomTypes, params);
        yield put(setListHomestayRoomTypesAction(result));
    }, errorHandleHomestayRoomType(Types.HOMESTAY_ROOM_TYPE_LIST_FAIL)))
}

// TRANSLATE
function* createHomestayRoomTypeTranslate() {
    yield takeLatest(Types.HOMESTAY_ROOM_TYPE_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HomestayRoomTypeService.createHomestayRoomTypeTranslate, action.homestayRoomType);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.homestayRoomType.translate.languageName);
        yield put({ type: Types.HOMESTAY_ROOM_TYPE_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.HOMESTAY_ROOM_TYPE_DETAIL_ACTION, id: action.homestayRoomType.id });
    }, errorHandleHomestayRoomType(Types.HOMESTAY_ROOM_TYPE_FAIL)))
}

function* updateHomestayRoomTypeTranslate() {
    yield takeLatest(Types.HOMESTAY_ROOM_TYPE_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HomestayRoomTypeService.updateHomestayRoomTypeTranslate, action.homestayRoomType);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.homestayRoomType.translate.languageName);
        yield put({ type: Types.HOMESTAY_ROOM_TYPE_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.HOMESTAY_ROOM_TYPE_DETAIL_ACTION, id: action.homestayRoomType.id });
    }, errorHandleHomestayRoomType(Types.HOMESTAY_ROOM_TYPE_FAIL)))
}

function* deleteHomestayRoomTypeTranslate() {
    yield takeLatest(Types.HOMESTAY_ROOM_TYPE_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HomestayRoomTypeService.deleteHomestayRoomTypeTranslate, action.homestayRoomType.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.homestayRoomType.translate.languageName);
        yield put({ type: Types.HOMESTAY_ROOM_TYPE_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.HOMESTAY_ROOM_TYPE_DETAIL_ACTION, id: action.homestayRoomType.id });
    }, errorHandleHomestayRoomType(Types.HOMESTAY_ROOM_TYPE_FAIL)))
}

function errorHandleHomestayRoomType(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'homestayRoomType');
}

function* setHomestayRoomTypeSaga() {
    yield takeLatest(Types.HOMESTAY_ROOM_TYPE_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(HomestayRoomTypeService.getHomestayRoomType, action.id);
        yield put(setHomestayRoomTypeAction(result));
    }, errorHandleHomestayRoomType(Types.HOMESTAY_ROOM_TYPE_DETAIL_FAIL)))
}

function* saveHomestayRoomTypeSaga() {
    yield takeLatest(Types.HOMESTAY_ROOM_TYPE_SAVE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HomestayRoomTypeService.saveHomestayRoomType, action.homestayRoomType);
        message.success(i18n.t(`validation.statusCode.code.${action.homestayRoomType.id ? '204':'201'}`));
        history.push(PATHS.HOMESTAY_ROOM_TYPE.LIST.path.replace(':homestay_id', action.homestayRoomType.hotelId));
        history.go();
    }, errorHandleHomestayRoomType(Types.HOMESTAY_ROOM_TYPE_SAVE_FAIL)))
}

function* setListHomestayRoomTypeByHotelSaga() {
    yield takeLatest(Types.HOMESTAY_ROOM_TYPE_ALL_HOTEL_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(HomestayRoomTypeService.getHomestayRoomTypeAllByHotel, action.id);
        yield put(setAllHomestayRoomTypesByHotel(result.data || []));
    }, errorHandleHomestayRoomType(Types.HOMESTAY_ROOM_TYPE_LIST_FAIL)))
}

export function* homestayRoomTypeSaga() {
    yield all([
        fork(setListHomestayRoomTypeSaga),
        fork(setHomestayRoomTypeSaga),
        fork(saveHomestayRoomTypeSaga),

        fork(createHomestayRoomTypeTranslate),
        fork(updateHomestayRoomTypeTranslate),
        fork(deleteHomestayRoomTypeTranslate),
        fork(setListHomestayRoomTypeByHotelSaga),
    ])
}
